import styled from "styled-components";
import { NavLink } from "react-router-dom";

export const Container = styled.main`
    display: flex;
    flex-direction: column;

    gap: 20px;
    height: 100%;
`;

export const Title = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    height: 10%;

    @media (max-width: 900px) {
        height: 20%;
    }
`;

export const Infor = styled.div``;

export const H4 = styled.p`
    font-size: 24px;
    font-weight: bold;
    color: ${(props) => props.theme.colors.gray.gray_800};
`;

export const H6 = styled.p`
    font-size: 16px;
    color: ${(props) => props.theme.colors.gray.gray_500};
`;

export const ContentButton = styled.div`
    display: flex;
    gap: 8px;
`;

// Inicio Container Table
export const TableContainer = styled.div` //ok - Responsável das medidas
  height: 75%;
  width: 100%;
  position: relative;
`;

export const ContentSph = styled.div`
    display: flex;
    align-items: center;
    
    height: 95%;
    width: 100%;
`;

export const TitleSpherical = styled.div`
    writing-mode: vertical-rl; /* Deixa o texto na vertical */
    transform: rotate(180deg); /* Ajusta para ficar legível */

    font-weight: 500;
    color: ${(props) => props.theme.colors.gray.gray_200};
    text-align: center;
`;

export const TitleCylindrical = styled.div`
    color: ${(props) => props.theme.colors.gray.gray_200};
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const ScrollableContainer = styled.div` //ok - Onde fica a parte do scroll em x e y
    height: 100%;
    width: 100%;
    overflow: auto;

    &::-webkit-scrollbar { 
        height: 10px;
        width: 10px;
        background-color: ${(props) => props.theme.colors.gray.gray_50};
    }
    &::-webkit-scrollbar-thumb { 
        background-color: ${(props) => props.theme.colors.gray.gray_100};
        border-radius: 8px;
    }
`;

export const Table = styled.table`
  border-collapse: collapse;
  position: relative;
  width: 100%;
`;

export const THead = styled.thead`
    position: sticky;
    top: 0;
    z-index: 2;

    background-color: ${props => props.theme.colors.gray.gray_600};
    color: ${props => props.theme.colors.white};
`;

export const CornerCell = styled.th`
    background-color: ${props => props.theme.colors.white};
    z-index: 3;
`;

export const Th = styled.th`
    border-right: 1px solid ${props => props.theme.colors.gray.gray_50};
    padding: 5px;
  `;

export const FixedCell = styled.th`
  position: sticky;
  left: 0;
  z-index: 10;
  background-color: ${props => props.theme.colors.gray.gray_600};
  color: ${props => props.theme.colors.white};
  padding: 5px;
`;

export const Td = styled.td`
    cursor: pointer;
    color: ${(props) => props.theme.colors.gray.gray_800};
    text-align: center;

    span{
        color: ${(props) => props.theme.colors.error};
    }

    &:hover {
        background-color: ${(props) => props.theme.colors.gray.gray_100};
    }

`;

export const TableRow = styled.tr`
    border-bottom: 1px solid ${props => props.theme.colors.gray.gray_50};
`;

export const TableRowHover = styled.tr`
    border-bottom: 1px solid ${props => props.theme.colors.gray.gray_50};

    &:hover {
        background-color: ${props => props.theme.colors.gray.gray_50};
    }
`;

export const TBody = styled.tbody``;
// Fim Container Table

export const Input = styled.input`
    &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
    text-align: center;
    width: 100%;
`;

export const ButtonTable = styled.button`
    width: 90%;
    background-color: transparent;
`;

export const Footer = styled.footer`
    display: flex;
    justify-content: space-between;
    height: 10%;
`;

export const StyledNavLink = styled(NavLink)`
    display: flex;
    align-items: center;
    color: ${(props) => props.theme.colors.gray.gray_600};
    text-decoration: none;
    gap: 4px;

  &:hover {
    text-decoration: underline;
  }
`;
